// @ core
const apiURLBuilder = require('core/apiURLBuilder');
const moment = require('moment');
// @ utilities
const get = require('lodash/object/get');
const uniq = require('lodash/array/uniq');
const trim = require('lodash/string/trim');
const { APIGet } = require('utilities/APIRequestHelper');
// @ constants
const actionTypes = require('constants/actionTypes');
const { DATE_FORMAT_API, TRANSFER_MAX_IMPORT, TRANSFER_MIN_IMPORT } = require('constants/index');

const emitedTransfersRequest = (accountId) => ({
    type: actionTypes.FETCH_EMITED_TRANSFERS_REQUEST,
    payload: {
        accountId
    }
})

const emitedTransfersNextPageRequest = (accountId) => ({
    type: actionTypes.FETCH_EMITED_TRANSFERS_NEXT_PAGE_REQUEST,
    payload: {
        accountId
    }
})

const emitedTransfersSuccess = (data, accountId) => ({
    type: actionTypes.FETCH_EMITED_TRANSFERS_SUCCESS,
    payload: {
        accountId,
        nextPage: get(data, '_links.nextPage.href', ''),
        transfers: get(data, 'lista.lista', [])
    }
})

const emitedTransfersFailure = (error, accountId) => ({
    type: actionTypes.FETCH_EMITED_TRANSFERS_FAILURE,
    payload: {
        accountId,
        error
    }
})

const requestNextAccountTransactionsPageSuccess = (data, accountId) => ({
    type: actionTypes.FETCH_EMITED_TRANSFERS_NEXT_PAGE_SUCCESS,
    payload: {
        accountId,
        nextPage: get(data, '_links.nextPage.href', ''),
        transfers: get(data, 'lista.lista', [])
    }
})

function getEmitedTransfers(dispatch, accountId, product, contractNumber, accountHoldersNames, filters) {
    // If there's no toDate defined, we use today minus 5 years (arbitrary long date)
    let toDate = get(filters, 'toDate') || moment().startOf('day');
    // If there's no fromDate defined, we use today as a limit
    let fromDate = get(filters, 'fromDate') || moment().startOf('day').subtract(5, 'year')

    let toAmount = get(filters, 'toAmount');
    let fromAmount = get(filters, 'fromAmount');
    let amountCurrency = get(filters, 'amountCurrency');

    const requestData = {
        query: {
            productoOrdenante: product,
            numeroContratoOrdenante: contractNumber,
            fechaInicial: fromDate.format(DATE_FORMAT_API),
            fechaFinal: toDate.format(DATE_FORMAT_API)
        }
    }

    // (jorge): The amount filter is allways required, that's why we set the default values for 'importeInicial' and 'importeFinal' filters
    requestData.query.importeInicial = fromAmount || TRANSFER_MIN_IMPORT;
    requestData.query.importeFinal = toAmount || TRANSFER_MAX_IMPORT;

    if (amountCurrency) {
        requestData.query.divisaInicial = amountCurrency;
        requestData.query.divisaFinal = amountCurrency;
    }

    dispatch(emitedTransfersRequest(accountId));
    return APIGet({
        dispatch,
        endpoint: 'emitedTransfers',
        url: apiURLBuilder.getURL('emitedTransfers'),
        params: requestData
    })
    .then(response => {
        get(response, 'lista.lista', []).forEach( transfer => {
            transfer.isPass = accountHoldersNames.includes(trim(transfer.beneficiario));
        })
        return dispatch(emitedTransfersSuccess(response, accountId))
    })
    .catch(response => dispatch(emitedTransfersFailure(response.error, accountId)));
}

const requestEmitedTransfers = accountId => (dispatch, getState) => {
    const immGlobalPosition = getState().globalPosition;
    if (!immGlobalPosition.get('isOutdated')) {
        // jorge.zapata If the PG has been invalidated, we don't do the request until it has been fetched again
        // This is to avoid repeated request after a transaction
        const immAccounts = getState().accounts;
        const immAccount = immAccounts.get('byId').get(accountId);
        // we identify all accounts holders names, to filter transfer between own accounts
        const accountHoldersNames = uniq(immAccounts.get('byOrder').map( accountId => {
            return immAccounts.getIn(['byId', accountId, 'accountHolder'])
        }).toJS())
        const immEmitedTransfersFilters = getState().emitedTransfers.get('filters');
        let filters = {};

        if (immEmitedTransfersFilters) {
            filters = {
                fromDate: immEmitedTransfersFilters.get('date').get('from'),
                toDate: immEmitedTransfersFilters.get('date').get('to'),
                fromAmount: immEmitedTransfersFilters.get('amount').get('from').get('amount'),
                toAmount: immEmitedTransfersFilters.get('amount').get('to').get('amount'),
                amountCurrency: immEmitedTransfersFilters.get('currency').get('value')
            }
        }

        return getEmitedTransfers(dispatch, accountId, immAccount.get('newProduct'), immAccount.get('newContractNumber'), accountHoldersNames, filters);
    } else {
        return Promise.resolve();
    }
}

const requestEmitedTransfersNextPage = (accountId) => (dispatch, getState) => {
    const immAccounts = getState().accounts;
    const nextPageURL = getState().emitedTransfers.get(accountId).get('nextPage');
    // we identify all accounts holders names, to filter transfer between own accounts
    const accountHoldersNames = uniq(immAccounts.get('byOrder').map( accountId => {
        return immAccounts.getIn(['byId', accountId, 'accountHolder'])
    }).toJS())

    dispatch(emitedTransfersNextPageRequest(accountId));
    return APIGet({
        dispatch,
        endpoint: 'emitedTransfers',
        url: nextPageURL
    })
    .then(response => {
        get(response, 'lista.lista', []).forEach( transfer => {
            transfer.isPass = accountHoldersNames.includes(trim(transfer.beneficiario));
        })
        return dispatch(requestNextAccountTransactionsPageSuccess(response, accountId));
    })
    .catch(response => dispatch(emitedTransfersFailure(response.error, accountId)))
}

const setEmitedTransfersFilters = (filters) => ({
    type: actionTypes.SET_EMITED_TRANSFERS_FILTERS, // tagged for analytics
    payload: {
        filters
    }
})

const resetEmitedTransfersFilter = (filter) => ({
    type: actionTypes.RESET_EMITED_TRANSFERS_FILTER,
    payload: {
        filter
    }
});

const clearEmitedTransfersFilters = () => ({
    type: actionTypes.CLEAR_EMITED_TRANSFERS_FILTERS // tagged for analytics
})

module.exports = {
    clearEmitedTransfersFilters,
    requestEmitedTransfers,
    requestEmitedTransfersNextPage,
    resetEmitedTransfersFilter,
    setEmitedTransfersFilters    
}
